import { useMutation } from '@tanstack/react-query'
import { depositToPortfolio } from 'services/RewardsService'

export const useDepositToPortfolioMutation = () =>
  useMutation({
    mutationFn: depositToPortfolio,
  })
